import { render, staticRenderFns } from "./twitter_2024.vue?vue&type=template&id=41a4f945&scoped=true"
import script from "./twitter_2024.vue?vue&type=script&lang=js"
export * from "./twitter_2024.vue?vue&type=script&lang=js"
import style0 from "./twitter_2024.vue?vue&type=style&index=0&id=41a4f945&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a4f945",
  null
  
)

export default component.exports